import {Component, OnChanges, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NumAnnoMeseFilterComponent} from '../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {ProviderModel} from 'src/models/ProviderModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';

@Component({
  selector: 'app-consuntivo-upload',
  templateUrl: './consuntivo-upload.component.html',
  styleUrls: ['./consuntivo-upload.component.scss']
})
export class ConsuntivoUploadComponent extends BaseGeneralComponent implements OnInit, OnDestroy, OnChanges {

  numAnnoMeseFormControl = new FormControl();
  numAnnoMese: number;
  allMonth: any;
  uploadType: string;
  showProvider: boolean;
  showActions: boolean;
  registerForm: FormGroup;
  providerSelect: ProviderModel;
  statusSelected: any;
  submitted: boolean;
  enableUpload: boolean;

  getAllNumAnnoMeseSubscribe: Subscription;
  getPageSubscribe: Subscription;

  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;

  constructor(private annoMeseService: NumAnnoMeseService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService) {
    super();
    this.showActions = false;
    this.providerSelect = new ProviderModel();
      this.enableUpload = false;
    this.registerForm = this.formBuilder.group({
      numAnnoMese: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      status: [{value: '', disabled: false}, Validators.required]
    });
  }

  ngOnInit() {
    this.loaderService.display(true);
    this.uploadType = 'consuntivo';
    // this.getFirstYearMonth();
    this.getAll();
  }

  ngOnChanges (changes: any) {
    this.numAnnoMese = changes;
    this.registerForm.patchValue({
      numAnnoMese: this.numAnnoMese
    });
  }

  getFirstYearMonth() {
    this.getPageSubscribe = this.annoMeseService.getFirtsAnnoMese()
      .subscribe(
        (numAnnoMeseResult: any) => {
          this.numAnnoMese = numAnnoMeseResult;
          this.registerForm.patchValue({
            numAnnoMese: this.numAnnoMese
          });
        });
  }

  getAll() {
    //TODO poco elegante questo modo di reperire il provider
    const providerDefault = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.getAllNumAnnoMeseSubscribe = this.annoMeseService.getAllMonth(providerDefault, new ContractTypeModel())
      .subscribe(
        (result: any) => {
          this.allMonth = this.filterFromDxc(providerDefault, result);
          this.numAnnoMese = this.allMonth[0];

          this.providerSelect = providerDefault;
          this.registerForm.patchValue({
            provider: this.providerSelect.cod
          });
          this.registerForm.patchValue({
            numAnnoMese: this.numAnnoMese
          });

          this.loaderService.display(false);
        });
  }

  getElementSelectedProvider($event) {
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
    if (this.statusSelected) {
      this.enableUpload = true;
    }
  }

  dataFiltered() {
  }

  ngOnDestroy(): void {
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  resetProvider() {
    this.showProvider = false;
    this.enableUpload = false;
    this.registerForm.patchValue({
      provider: null
    });
    this.providerSelect = new ProviderModel();
  }

  getElementSelectedStatus($event) {
    this.statusSelected = $event;
    this.enableUpload = true;

    this.registerForm.patchValue({
      status: this.statusSelected
    });
  }

  onFileUploading() {
    this.loaderService.display(true);
  }

  onFileComplete() {
    this.loaderService.display(false);
  }

  get f() { return this.registerForm.controls; }

}
